import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import PrivacyNotice from './pages/PrivacyNotice';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';

function App() {
  // Add error boundary and debugging
  console.log('App component rendering...');
  
  return (
    <HelmetProvider>
      <ThemeProvider>
      <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="Features" element={<Features />} />
          <Route path="privacy-notice" element={<PrivacyNotice />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="frequently-asked-questions-and-feedback" element={<FAQ />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
      </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;